import building from 'plugins/i18n/entity/building.de.ts'
import meter from 'plugins/i18n/entity/meter.de.ts'
import common from 'plugins/i18n/common.de.ts'

const meterLevel = {
	name: 'Zählerstand',
	fields: {
		read_off_at: 'Abgelesen am',
		value: 'Frzgb. Zählerstand',
		building: {
			name: building.name,
			...building.fields,
		},
		meter: {
			...meter.fields,
		},
		created: common.createdAt,
	},
}

export default meterLevel
